module.exports = __webpack_public_path__ + "media/site/images/banners/banner-development-4dd415060bc8cd48d17c01dffffaaad6.svg";